<template>
	<form class="form form--invite invite-form" ref="form" @submit.prevent.stop="submitForm(fields)">
		<div class="form-section">
			<div class="form-row">
				<TextField class="form__field" id="email" v-model="fields.email" label="Email Address" type="email" autocomplete="email" :required="true" />
				<TextField class="form__field" id="firstName" v-model="fields.firstName" label="First Name" autocomplete="given-name" :required="true" />
				<TextField class="form__field" id="lastName" v-model="fields.lastName" label="Last Name" autocomplete="family-name" :required="true" />
				<TextField class="form__field" id="password" v-model="fields.password" label="Password" :type="passwordType" :required="true" hint="Minimum 8 characters, 1 uppercase, 1 numeric" pattern="^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$">
					<template v-slot:post><i class="material-icons" @click="passwordType = passwordType == 'password' ? 'text' : 'password'" v-html="passwordType == 'password' ? 'visibility_on': 'visibility_off'"></i></template>
				</TextField>
				<label class="form__field form__label">
					<input class="form__input" type="checkbox" v-model="fields.contact" />
					I want news and updates about Sentencing Pro.
				</label>
			</div>
			<div class="form__actions form__actions--horizontal">
				<Button type="submit" look="form" :disabled="isLoading || !$refs.form?.checkValidity()" :loading="isLoading">Register</Button>
			</div>
		</div>
	</form>
</template>

<script>
import Button from '@/components/Button.vue'
import TextField from '@/components/TextField.vue'

import { useUserStore } from '@/lib/store/user'

export default {
	name: 'InviteForm',
	components: {
		Button,
		TextField,
	},
	setup() {
		const userStore = useUserStore()

		return {
			userStore,
		}
	},
	props: {
		redirect: true,
	},
	data: () => ({
		fields: {
			contact: true,
		},
		passwordType: 'password'
	}),
	mounted() {
		if (this.userStore.claims?.metadata?.userLevel == 'demo') {
			this.fields.email = this.userStore.claims?.email
			this.fields.uid = this.userStore.claims?.uid
		}
	},
	computed: {
		userClaims() {
			return this.userStore?.claims
		},
		isLoading() {
			return this.userStore.isLoading
		}
	},
	methods: {
		submitForm(fields) {
			// if (fields.password != fields.passwordConfirm) {
			// 	return this.$notice.show(`Password fields do not match.`)
			// }

			this.userStore.register(fields)
				// .then(res => {
				// 	if(this.redirect) {
				// 		this.$router.push({name: 'calculator'})
				// 	}
				// })
				.catch(error => {
					this.$notice.show(`ERROR: ${error.message || error}`)
				})
		},
	},
}
</script>

<style scoped lang="scss">
.mdc-text-field {
	.material-icons {
		max-width: 24px;
	}
}
</style>
